(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > 10) { this.classList.add('scrolled'); } else { this.classList.remove('scrolled'); }
      this.currentScrollTop = scrollTop;
    }
  }
  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', function() {
    const menuButton = document.getElementById('mobile-menu-button');
    const menuClose = document.getElementById('mobile-menu-close');
    const menuOverlay = document.getElementById('mobile-menu-overlay');
    const menu = document.getElementById('mobile-menu');
    if (!menuButton || !menu) return;
    let scrollPosition = 0;
    function openMenu() {
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.top = `-${scrollPosition}px`;
      document.body.classList.add('menu-open');
      menu.classList.add('active');
      menuOverlay.classList.add('active');
    }
    function closeMenu() {
      document.body.classList.remove('menu-open');
      document.body.style.top = '';
      menu.classList.remove('active');
      menuOverlay.classList.remove('active');
      window.scrollTo(0, scrollPosition);
    }
    menuButton.addEventListener('click', openMenu);
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    if (menuOverlay) menuOverlay.addEventListener('click', closeMenu);

    // Kontakt/Support anchor – funktioniert auf allen Seiten
    var supportLinks = document.querySelectorAll('.support-anchor');
    supportLinks.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var kontaktEl = document.getElementById('kontakt');
        if (kontaktEl) {
          e.preventDefault();
          closeMenu();
          setTimeout(function() {
            kontaktEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 350);
        }
        // Kein preventDefault wenn kein #kontakt Element – normaler Link zu /pages/kontakt
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
